import httpClient from './httpClient';
import {
  ComponentProjectMetricDetailResponse,
  ComponentProjectMetricsResponse,
  DashboardMetricsResponse,
} from '../types/dashboard';

export interface DashboardQueryParams {
  start?: string;
  end?: string;
  grain?: 'quarter';
  sectionId?: string;
}

export const dashboardApi = {
  getDashboardMetrics: async (
    groupId: string,
    params: DashboardQueryParams = {}
  ): Promise<DashboardMetricsResponse> => {
    const response = await httpClient.get(`/v1/dashboard/${encodeURIComponent(groupId)}/metrics`, {
      params,
    });
    return response.data;
  },

  getComponentProjectMetrics: async (
    componentProjectId: string,
    params: DashboardQueryParams & { includeGoals?: boolean } = {}
  ): Promise<ComponentProjectMetricsResponse> => {
    const { includeGoals = true, ...queryParams } = params;
    const response = await httpClient.get<ComponentProjectMetricsResponse>(
      `/v1/dashboard/component-projects/${encodeURIComponent(componentProjectId)}/metrics`,
      {
        params: {
          ...queryParams,
          includeGoals,
        },
        headers: {
          'X-Admin-Scope': 'all',
        },
      }
    );
    return response.data;
  },

  getComponentProjectMetric: async (
    componentProjectId: string,
    metricId: string,
    params: Omit<DashboardQueryParams, 'sectionId'> & { includeGoals?: boolean } = {}
  ): Promise<ComponentProjectMetricDetailResponse> => {
    const { includeGoals = true, ...queryParams } = params;
    const response = await httpClient.get<ComponentProjectMetricDetailResponse>(
      `/v1/dashboard/component-projects/${encodeURIComponent(componentProjectId)}/metrics/${encodeURIComponent(metricId)}`,
      {
        params: {
          ...queryParams,
          includeGoals,
        },
        headers: {
          'X-Admin-Scope': 'all',
        },
      }
    );
    return response.data;
  },
};
